module.exports = __webpack_public_path__ + "img/public-opinion.26a20f85.png";